module.exports = __webpack_public_path__ + "img/placeholder-port.a270af57.svg";